export var getMortageDetailsMapper = function (data) {
    var result = [];
    if (data && data.length != 0) {
        result = data.map(function (item) {
            return {
                acCode: item === null || item === void 0 ? void 0 : item.accode,
                categoryId: item === null || item === void 0 ? void 0 : item.categoryid,
                categoryName: item === null || item === void 0 ? void 0 : item.categoryname,
                createdBy: item === null || item === void 0 ? void 0 : item.createdby,
                cxid: item === null || item === void 0 ? void 0 : item.cxid,
                dealerCode: item === null || item === void 0 ? void 0 : item.dealercode,
                loanId: item === null || item === void 0 ? void 0 : item.loanid,
                TypeOfLoan: item === null || item === void 0 ? void 0 : item.typeofloan,
                pan: item === null || item === void 0 ? void 0 : item.pan,
                productId: item === null || item === void 0 ? void 0 : item.productid,
                subcategoryId: item === null || item === void 0 ? void 0 : item.subcategoryid,
                subcategoryName: item === null || item === void 0 ? void 0 : item.subcategoryname,
                productName: item === null || item === void 0 ? void 0 : item.productname,
                switchToEdelwiess: item === null || item === void 0 ? void 0 : item.switchtoedelwiess,
                otherInstitution: item === null || item === void 0 ? void 0 : item.otherinstitution,
                InstitutionId: item === null || item === void 0 ? void 0 : item.institutionid,
                InstitutionName: item === null || item === void 0 ? void 0 : item.institutionname,
                ROI: item === null || item === void 0 ? void 0 : item.roi,
                SanctionAMT: item === null || item === void 0 ? void 0 : item.sanctionamt,
                LoanDisbursmentAMT: item === null || item === void 0 ? void 0 : item.loandisbursmentamt,
                OutstandingAMT: item === null || item === void 0 ? void 0 : item.outstandingamt,
                TypeOfROI: item === null || item === void 0 ? void 0 : item.typeofroi,
                BalanceTransfer: item === null || item === void 0 ? void 0 : item.balancetransfer,
                TaskId: item === null || item === void 0 ? void 0 : item.taskid,
                LSTIinstitution: item === null || item === void 0 ? void 0 : item.lstinstitution.map(function (items) {
                    return {
                        InstitutionId: items === null || items === void 0 ? void 0 : items.institutionid,
                        InstitutionName: items === null || items === void 0 ? void 0 : items.institutionname,
                    };
                }),
            };
        });
    }
    return result;
};
